import { TriggerBonusAction } from "../actions/creators/triggerBonusCreator"

const init = {
    loading: false,
    response: null,
    error: null,
}

export default function (state = init, action) {
    switch (action.type) {
        case TriggerBonusAction.sendTriggerBonusSuccess:
            return { ...state, response: action.payload, error: null }
        case TriggerBonusAction.sendTriggerBonusLoading:
            return { ...state, response: null, loading: true }
        case TriggerBonusAction.sendTriggerBonusLoaded:
            return { ...state, loading: false }
        case TriggerBonusAction.sendTriggerBonusError:
            return { ...state, error: action.payload, response: null }

        case TriggerBonusAction.getTriggerBonusLoading: // reset response when getting triggerBonus
            return { ...state, response: null }
        default:
            return state
    }
}
